export const isPasswordComplexityOK = (password) => {
  return /(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&.])[A-Za-z\d@$!%*?&.]{8,}/.test(
    password,
  )
}

export const isLoggedIn = () => {
  const storedToken = localStorage.getItem('token')
  return !!storedToken
}
